/* bd-glance-modal.js */
(function () {
  'use strict';

  const initGlanceSection = () => {
    const containers = document.querySelectorAll('.bd-glance__container');

    containers.forEach((container) => {

      /* =========================
         Accordion Logic
      ========================== */

      container.addEventListener('click', (e) => {
        const trigger = e.target.closest('[data-bd-accordion-trigger]');
        if (!trigger) return;

        const item = trigger.closest('[data-bd-accordion-item]');
        const contentId = trigger.getAttribute('aria-controls');
        const content = document.getElementById(contentId);

        if (!item || !content) return;

        const isOpen = item.classList.contains('is-open');

        // Toggle the clicked item open or closed
        if (isOpen) {
          item.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
          content.setAttribute('aria-hidden', 'true');
        } else {
          item.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
          content.setAttribute('aria-hidden', 'false');
        }
      });


      /* =========================
         Hardness Tabs Logic
      ========================== */

      container.addEventListener('click', (e) => {
        const btn = e.target.closest('.bd-glance__hardness-btn');
        if (!btn) return;

        const wrapper = btn.closest('[data-bd-hardness-component]');
        if (!wrapper) return;

        const allBtns = wrapper.querySelectorAll('.bd-glance__hardness-btn');
        const contents = wrapper.querySelectorAll('.bd-glance__hardness-text');
        const index = btn.dataset.index;

        // Update buttons
        allBtns.forEach((b) => {
          b.classList.remove('is-active');
          b.setAttribute('aria-selected', 'false');
        });

        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');

        // Update content
        contents.forEach((content) => {
          if (content.dataset.contentIndex === index) {
            content.classList.add('is-active');
            content.setAttribute('aria-hidden', 'false');
          } else {
            content.classList.remove('is-active');
            content.setAttribute('aria-hidden', 'true');
          }
        });
      });

    });
  };

  document.addEventListener('DOMContentLoaded', initGlanceSection);
  document.addEventListener('shopify:section:load', initGlanceSection);

})();